/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Operationhoursp12Inputs */



/**
* | output |
* | --- |
* | "Operation hours left/high pump" |
*
* @param {Br_History_Key_Operationhoursp12Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_operationhoursp12 = /** @type {((inputs?: Br_History_Key_Operationhoursp12Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Operationhoursp12Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Operation hours left/high pump")
	return /** @type {LocalizedString} */ ("Heures de fonctionnement pompe gauche/haute")
});
export { br_history_key_operationhoursp12 as "br_history_key_operationHoursP1" }